<template>
  <div>
    <PhoneGuideDialog v-if="show" @close="show = false" />

    <div class="BottomBanner-box" @click.stop="registerFn">
      <div class="BottomBanners">
        <img
          class="BottomBanner-bg"
          :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-bg.png`"
          alt=""
        />
        <div class="BottomBanner-cont">
          <img
            class="BottomBanner-wa"
            @click.stop="showDialog"
            :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-wa.png`"
            alt=""
          />
          <div class="BottomBanner-btnBox">
            <img
              class="BottomBanner-btn"
              @click.stop="registerFn"
              :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-btn.png`"
              alt=""
            />
            <img
              class="BottomBanner-close"
              @click.stop="$emit('close')"
              :src="`${CDN}/0cdn/static/front/qlmBidding1_ForJSP/img/BottomBanner-close.png`"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PhoneGuideDialog from "../PhoneGuideDialog/PhoneGuideDialog";
import { CDN } from "../../utils";
import { buryPointInsertRecordPoint } from "../../services/common";

export default {
  name: "BottomBanner", // 注意这个name是必须的
  components: {
    PhoneGuideDialog,
  },
  data() {
    return {
      CDN,
      show: false,
    };
  },
  methods: {
    hasZb() {
      let url = window.location.href;
      if (url.indexOf("zb/detail") > 0) {
        return true;
      } else {
        return false;
      }
    },
    registerFn() {
      console.log("注册");
      this.$emit("register");
    },
    //弹窗曝光
    showDialog() {
      if (this.hasZb()) return;
      this.show = true;
      let obj = {
        oid: "86",
        deed: "3", //曝光类型
        source: "gw",
        level: "0",
        uid: 0,
        ctxid: "",
        url: "",
        refer: "",
      };
      buryPointInsertRecordPoint(obj);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.BottomBanner-box {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 0;
  z-index: 2222;
}
.BottomBanners {
  position: relative;
  width: 100%;
  height: 60px;
  overflow: hidden;
  cursor: pointer;
}
.BottomBanner-bg {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
}
.BottomBanner-cont {
  position: absolute;
  top: 0;
  height: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 70%;
  min-width: 1000px;
  max-width: 1100px;
  overflow: hidden;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .BottomBanner-wa {
    height: 80px;
    width: 736px;
    cursor: pointer;
  }
  .BottomBanner-btn {
    height: 30px;
    cursor: pointer;
  }
  .BottomBanner-btnBox {
    display: flex;
    align-items: center;
  }
  .BottomBanner-close {
    height: 20px;
    cursor: pointer;
    margin-left: 50px;
  }
}
</style>
